module.exports = __webpack_public_path__ + "img/player-splash.c292f27f.png";